export default "__VITE_ASSET__DqXOfdul__"